module.exports = __webpack_public_path__ + "static/media/logo-호두랩스@3x.4a52fe8a.png";